module.exports = __webpack_public_path__ + "static/media/Apple Watch 42mm Sport Aluminum Rose Gold + Stone Closed.e38824c2.png";